import styled from 'styled-components';
import { Table, Input } from 'antd';

export const PoolTable = styled(Table)`
  .ant-table-scroll {
    overflow: hidden;
  }
  .ant-table {
    .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
      & > tr > th {
        color: ${props => props.theme.fontColors.thead};;
        letter-spacing: ${props => props.theme.letterSpacing.point6};
        background-color:#ffffff;
        padding: 0 16px 24px;
      }
    }
    .ant-table-header {
      background-color:#ffffff;
      margin-bottom:0px!important;
      overflow: auto !important;
    }
    .ant-table-tbody {
      font-family: ${props => props.theme.fontFamily.helveticaNeue};
      & > tr > td {
       color: ${props => props.theme.fontColors.tbody};
        letter-spacing: ${props => props.theme.letterSpacing.point6};
      }
      & > tr > td > input {
          width: 100px;
          text-align: center !important;
          float: right;
          margin-right: 19px;
          &:focus, &:active {
            border: 1px solid #505050;
          }

      }
    }
  }
`;

export const ExchangeFromTable = styled(PoolTable)`
  .ant-table-row:nth-child(2n + 1) {
      background-color: ${props => props.theme.backgroundColor.tableAltRowDark}!important;
    }
  
  .ant-input-number {
    width: 100%!important;
    .ant-input-number-handler-wrap {
      display: none;
    }
  }
  .ant-table-body {
    overflow-y: unset !important;
  }
`;

export const FromTableFooter = styled.div`
  width: 70%;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.point6};
  align-items: center;

`;

export const TableInputWrapper = styled(Input)`
background-color: #f4f3f3;
`;

export const TotalSpan = styled.span`
  float: right;
  margin-right: 10px;
  line-height: 24px;
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.thead};
  font-size: 18px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const TotalPercentDiv = styled.div`
  float: right;
  margin-right: 10px;
  line-height: 24px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: 16px;
  color: ${props => props.theme.fontColors.textColor};
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
    line-height: 20px;
  }

`;

export const HeaderStyle = styled.span`
  font-family: HelveticaNeue-Bold;
  font-size: 16px;
  letter-spacing: 0.57px;
  line-height: 1.38;
  color: #505050;
`;

export const HeaderStyle2 = styled.div`
  font-family: HelveticaNeue !important;
  font-size: 16px;
  font-weight: normal;
  letter-spacing: 0.6px;
  color: #505050;
`;

export const Triangle = styled.img`
margin: 0 0 3px 5px;
`;

export const InvestmentOption = styled.div`
font-family: HelveticaNeue;
font-size: 16px;
line-height: 1.38;
letter-spacing: 0.57px;
color: #006778;
padding-left: 4px;
text-decoration:underline;
cursor:pointer;
`;

export const FooterWrapper = styled.div`
.ant-table-footer{
  padding: 20px 16px 0px 20px;
  margin-bottom: 20px;
  background: #ffffff;
}
`;

export const TotalFooter = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  color: ${props => props.theme.fontColors.headingColor};
`;

export const SpaceWrapper = styled.div`
  letter-spacing: ${props => props.theme.letterSpacing.zero};
`;
